import api from 'config/api'
import axios from 'axios'

axios.defaults.baseURL = api.url
axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'

const namespaced = true

const state = {
  code: 0,
  status: '',
  message: '',
  roles: api.roles,
  uuid: localStorage.uuid || 0,
  rolID: localStorage.rolID || 0,
  hasCredentials: false
}

const getters = {

  /**
   * Get api configuration.
   *
   * @return {Object}
   */
  hasCredentials: state => {
    return state.hasCredentials
  },

  /**
   * Get api configuration.
   *
   * @return {Object}
   */
  getUserRol: state => {
    return api.roles[state.rolID - 1] || 'guest'
  },

  /**
   * Get api configuration.
   *
   * @return {Object}
   */
  getUserId: state => {
    return state.uuid
  },

  /**
   * Get api configuration.
   *
   * @return {Object}
   */
  getStatus: state => {
    return state.status
  },

  /**
   * Get api configuration.
   *
   * @return {Object}
   */
  getMessage: state => {
    return state.message
  }
}

const actions = {

  /**
   * Set api options.
   *
   * @param {Object} context → vm
   * @param {Object} state   → store payload
   * @param {Object} payload    → api params
   */
  request ({ dispatch, commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit('loading')
      let data = payload.data || []
      if (payload.data && payload.method !== 'put') {
        data = new FormData()
        Object.keys(payload.data).map((key) => {
          data.set(key, payload.data[key])
        })
      }
      return axios({
        method: payload.method,
        url: payload.url,
        data: data
      }).then(response => {
        commit('success')
        commit('code', response.status)
        commit('message', response.statusText)
        resolve(response)
      }).catch(error => {
        console.log(error.response)
        commit('error')
        commit('code', error.status)
        commit('message', error.response.data ? error.response.data.message : false || error.response.statusText)
        if (error.response.status === 401) {
          dispatch('logout')
          // location.reload()
        }
        reject(error)
      })
    })
  },

  /**
   * Set api options.
   *
   * @param {Object} context → vm
   * @param {Object} state   → store payload
   * @param {Object} payload → api params
   */
  authRequest ({ dispatch, commit, state }, payload) {
    return new Promise((resolve, reject) => {
      payload.url = payload.url + api.sufix
      dispatch('prepareAuthorization').then(response => {
        dispatch('request', payload).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * Set api options.
   *
   * @param {Object} context → vm
   * @param {Object} state   → store payload
   * @param {Object} payload    → api params
   */
  prepareAuthorization ({ dispatch, commit, state }, payload) {
    return new Promise((resolve, reject) => {
      dispatch('hasCredentials').then(response => {
        if (response) {
          axios.defaults.headers.common['Authorization'] = response.accessToken

          // For new implementation
          // let nowTime = Date.now()
          // let expirationDate = new Date(response.expiresIn)
          // let expirationTime = expirationDate.getTime()
          // let remainingSeconds = expirationTime - nowTime

          let now = Date.now()
          let expiresIn = new Date(response.expiresIn || -1)
          let remainingSeconds = (expiresIn - now) / 1000
          if (remainingSeconds < 60) {
            axios.defaults.headers.common['Authorization'] = response.refreshToken
            dispatch('request', {
              method: 'post',
              url: api.token_renewal_route + api.sufix,
              data: { old_access_token: response.accessToken }
            }).then(response => {
              dispatch('setCredentials', response.data)
              resolve(response)
            }).catch(error => {
              dispatch('logout')
              reject(error)
            })
          }
          resolve(true)
        }
      })
    })
  },

  /**
   * Set api options.
   *
   * @param {Object} context → vm
   * @param {Object} state   → store payload
   * @param {Object} payload    → api params
   */
  hasCredentials ({ dispatch, commit, state }, payload) {
    return new Promise((resolve, reject) => {
      let expiresIn = localStorage.expiresIn || null
      let accessToken = localStorage.accessToken || null
      let refreshToken = localStorage.refreshToken || null
      let uuid = localStorage.uuid || null
      let rolID = localStorage.rolID || null
      if (accessToken && refreshToken && expiresIn && uuid && rolID) {
        commit('hasCredentials')
        resolve({
          accessToken: accessToken,
          refreshToken: refreshToken,
          expiresIn: expiresIn,
          uuid: uuid,
          rolID: rolID
        })
      }
      resolve(false)
    })
  },

  /**
   * Set api options.
   *
   * @param {Object} context → vm
   * @param {Object} state   → store payload
   * @param {Object} payload    → api params
   */
  setCredentials ({ dispatch, commit, state }, payload) {
    return new Promise((resolve, reject) => {
      let accessToken = payload.access_token || ''
      let refreshToken = payload.refresh_token || ''
      let expiresIn = payload.expires_in || ''
      let uuid = payload.uuid || ''
      let rolID = payload.rol_id || ''
      localStorage.setItem('accessToken', accessToken)
      localStorage.setItem('refreshToken', refreshToken)
      localStorage.setItem('expiresIn', expiresIn)
      localStorage.setItem('uuid', uuid)
      localStorage.setItem('rolID', rolID)
      axios.defaults.headers.common['Authorization'] = accessToken
      if (accessToken && refreshToken && expiresIn && uuid && rolID) {
        commit('hasCredentials')
        resolve(true)
      } else {
        dispatch('logout')
        resolve(false)
      }
    })
  },

  /**
   * Set api options.
   *
   * @param {Object} context → vm
   * @param {Object} state   → store payload
   * @param {Object} payload    → api params
   */
  logout ({ dispatch, commit, state }, payload) {
    return new Promise((resolve, reject) => {
      localStorage.clear()
      delete axios.defaults.headers.common['Authorization']
      commit('logout')
      resolve(true)
    })
  }
}

const mutations = {

  /**
   * Set api options.
   *
   * @param {Object} state → store payload
   * @param {Object} payload  → api params
   */
  loading (state) {
    state.status = 'loading'
  },

  /**
   * Set api options.
   *
   * @param {Object} state → store payload
   * @param {Object} payload  → api params
   */
  success (state) {
    state.status = 'success'
  },

  /**
   * Set api options.
   *
   * @param {Object} state → store payload
   * @param {Object} payload  → api params
   */
  error (state) {
    state.status = 'error'
  },

  /**
   * Set api options.
   *
   * @param {Object} state → store payload
   * @param {Object} payload  → api params
   */
  message (state, message) {
    state.message = message
  },

  /**
   * Set api options.
   *
   * @param {Object} state → store payload
   * @param {Object} payload  → api params
   */
  code (state, code) {
    state.code = code
  },

  /**
   * Set api options.
   *
   * @param {Object} state → store payload
   * @param {Object} payload  → api params
   */
  hasCredentials (state, payload) {
    state.hasCredentials = true
  },

  /**
   * Set api options.
   *
   * @param {Object} state → store payload
   * @param {Object} payload  → api params
   */
  logout (state) {
    state.hasCredentials = false
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/api.js